




import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import {accelerometerColorScheme} from '@u/colorSchemes';
import {AxisBoundaries} from '@/components/widgets/base/bindForms/interfaces';

@Component({
  components: {
    highcharts: Chart,
  },
})
export default class AccelerometerSegmentDiagramLine extends Vue {
  //Границы диаграммы по оси X
  @Prop({required: true, type: Object})
  axisBoundaries!: AxisBoundaries;

  @Prop({required: false})
  commonBoundaries!: AxisBoundaries;

  //Ключ для обновления размеров диаграммы
  @Prop({required: false, type: Number, default: 0})
  resizedKey!: number;

  @Watch('resizedKey')
  onResizedKeyChanged() {
    this.getChart().reflow();
  }

  //Объект графика
  getChart() {
    return (this.$refs.chart as any).chart;
  }

  //Т.к. есть вероятность, что не будет указана граница errorBoundary,
  // то для избежания ошибки ищем максимальное среди границ
  getMaxBoundary() {
    return Math.max(...Object.values(this.commonBoundaries).map(b => b ?? 0));
  }

  //Объект конфигурации графика
  get chartOptions() {
    const series = [];
    const boundaries = this.commonBoundaries;

    //порядок добавления серий важен для прорисовки
    if (boundaries.dangerBoundary && boundaries.errorBoundary)
      series.push({
        type: 'bar',
        color: accelerometerColorScheme.dangerColor,
        data: [boundaries.errorBoundary - boundaries.dangerBoundary],
      });

    if (boundaries.warningBoundary && boundaries.dangerBoundary)
      series.push({
        type: 'bar',
        color: accelerometerColorScheme.warningColor,
        data: [boundaries.dangerBoundary - boundaries.warningBoundary],
      });

    if (boundaries.warningBoundary)
      series.push({
        type: 'bar',
        color: accelerometerColorScheme.normalColor,
        data: [boundaries.warningBoundary],
      });

    return {
      credits: {
        enabled: false,
      },
      chart: {
        marginLeft: 0,
        marginRight: 0,
        spacingLeft: 0,
        spacingRight: 0,
        marginTop: 0,
        marginBottom: 0,
        spacingTop: 0,
        spacingBottom: 0,
        animation: false,
      },
      navigation: {
        buttonOptions: {
          enabled: false,
        },
      },
      plotOptions: {
        bar: {
          enableMouseTracking: false,
          pointWidth: 10,
          animation: false,
        },
        series: {
          stacking: 'normal',
          groupPadding: 0,
          pointPadding: 0,
          borderWidth: 0,
        },
      },
      tooltip: {
        enabled: false,
      },
      yAxis: {
        min: 0,
        max: this.getMaxBoundary(),
        visible: false,
        endOnTick: false,
      },
      title: {
        text: '',
      },
      legend: {
        enabled: false,
      },
      series,
    };
  }
}
